import { widgetViewNames } from 'src/constants/widgets';

/**
 * @return {boolean}
 */
export const isRescueNetNoPcr = state =>
  state.widgetView.name === widgetViewNames.rescueNetNoEPCR;
